import * as THREE from 'three';
const Perlin = require('../../utils/perlin.js').Perlin;
import anime from 'animejs';

export default class Terrain {

    constructor(config) {

        let defaultConfig = {
            width:24000,
            length:24000,
            widthSegments:60,
            lengthSegments: 60,
            smoothing:300,
            peak:100,
            dotSize:20,
            vertDot: '/skins/default/graphics/vert-dot.png'
        };

        this.config = deepmerge(defaultConfig, config);


    }

    getTerrain(object){

        let geometry = object.children[0].geometry;

       let vertices = geometry.attributes.position.array;
        let xyran    = 600;
        for (let i = 0; i <= vertices.length; i += 3) {
            vertices[i]   = vertices[i] + ((Math.random() * xyran) - Math.random() * xyran/2);
            vertices[i+1] = vertices[i+1] + ((Math.random() * xyran) - Math.random() * xyran/2);
        }

        let texture  = new THREE.TextureLoader().load( this.config.vertDot );
        let material = new THREE.PointCloudMaterial({
            size: this.config.dotSize, map: texture, transparent: true, fog:true
        });

        this.topterrain = new THREE.PointCloud( geometry, material );
        this.topterrain.sortParticles = true;

        this.subterrain = this.makePerlinPlane();

        let return_obj = new THREE.Object3D();
        return_obj.add(this.topterrain);
        return_obj.add(this.subterrain);
        this.subterrain.position.y = -200;

        //this.animateTerrain();

        return return_obj;

    }

    animateTerrain(){

        let randomseed = 40;
        let self       = this;

        let duration = Math.random() * 10000 + 5000;

        window.animationapi.registeranimation({
            targets: self.subterrain.rotation,
            x: (Math.random() / randomseed) - (Math.random() / randomseed),
            y: (Math.random() / randomseed) - (Math.random() / randomseed),
            z: (Math.random() / randomseed) - (Math.random() / randomseed),
            easing: 'easeInOutQuad',
            duration:duration,
            complete: function(anim) {
                self.animateTerrain();
            }
        });

        window.animationapi.registeranimation({
            targets: self.topterrain.rotation,
            x: (Math.random() / randomseed) - (Math.random() / randomseed),
            y: (Math.random() / randomseed) - (Math.random() / randomseed),
            z: (Math.random() / randomseed) - (Math.random() / randomseed),
            easing: 'easeInOutQuad',
            duration:duration
        });

    }

    makePerlinPlane() {

        let perlin = new Perlin();
        let dummy_geometry = new THREE.PlaneBufferGeometry( this.config.width, this.config.length, this.config.widthSegments, this.config.lengthSegments );

        let vertices = dummy_geometry.attributes.position.array;
        let xyran    = 840;

        for (let i = 0; i <= vertices.length; i += 3) {

            vertices[i+2] = this.config.peak * perlin.noise(
                (0 + vertices[i])/this.config.smoothing,
                (0 + vertices[i+1])/this.config.smoothing
            );

           vertices[i]   = vertices[i] + ((Math.random() * xyran) - Math.random() * xyran/2);
           vertices[i+1] = vertices[i+1] + ((Math.random() * xyran) - Math.random() * xyran/2);
        }

        dummy_geometry.needsUpdate = true;
        dummy_geometry.computeVertexNormals();

        let texture  = new THREE.TextureLoader().load( this.config.vertDot );
        let material = new THREE.PointCloudMaterial({
            size: this.config.dotSize, map: texture, transparent: true, fog:true
        });

        let particles = new THREE.PointCloud( dummy_geometry, material );
        particles.sortParticles = true;

        return particles;

    }


}




